<script lang="ts">
	import ApplicationForm from "@components/ApplicationForm.svelte";
	import Banner from "@components/Banner.svelte";
	import OrganizerCard from "@components/OrganizerCard.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { getTranslate } from "@utils/translate.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./Application.translations.json" with { type: "json" };
	import type { ApplicationProps } from "./ApplicationProps.js";

	const _: ApplicationProps = $props();
	const { competition } = getGlobalTemplateProps();

	const translate = getTranslate(translations);
	const registrationStarted = new Date() > (competition ? new Date(competition.registrationStart) : new Date());
	const registrationEnded = new Date() > (competition ? new Date(competition.registrationEnd) : new Date());
</script>

<Layout>
	{#if competition}
		<!-- One shared-width column keeps the banner, form and organizer on the same
		     left/right edges instead of jumping between widths. -->
		<div class="mx-auto w-full max-w-5xl">
			<Banner {competition} />

			{#if !registrationStarted}
				<div class="border-ink-200 shadow-card text-ink-600 mb-14 max-w-2xl rounded-xl border bg-white p-5 sm:p-6">
					{translate("registrationHasntStarted")}
				</div>
			{:else if !registrationEnded}
				<ApplicationForm {competition} />
			{:else}
				<div class="border-ink-200 shadow-card text-ink-600 mb-14 max-w-2xl rounded-xl border bg-white p-5 sm:p-6">
					{translate("registrationEnded")}
				</div>
			{/if}

			<!-- Organizer sits below the form — a reference block, not a gate to the CTA. -->
			<OrganizerCard {competition} class="max-w-3xl" />
		</div>
	{/if}
</Layout>
